import React from 'react';
import { IonModal, IonGrid, IonRow, IonCol, IonContent, IonButton, IonImg } from '@ionic/react';

import { MenuItem_Add } from './AddMenuItem';

import '../css/hotelCss.css';

export function MenuModal(props) {

    function closeModalHandler() {

        props.closeModal(false);
    }

    return (
    <React.Fragment>
        {props.openModal == true ?
        (
        <IonModal isOpen={ props.openModal }>
        <IonContent className='occupiedDetails_gridContent'>
            <MenuItem_Add data={{
                                        fileLocation: props.data.roomGuestInvoiceAttachment, 
                                        roomID: props.data.roomID, 
                                        roomSalePrice: props.data.roomSalePrice,
                                        invoiceID: props.data.invoiceID,
                                        customerInvoiceID: props.data.customerInvoiceID,
                                        }}></MenuItem_Add>

            <IonGrid class='gridModalFooter'>
                <IonButton onClick={closeModalHandler}> Close </IonButton>
            </IonGrid>
        </IonContent>
        </IonModal>) : null}
    </React.Fragment>
    )
}